<!-- <div class="card"> -->
@if (allBookmarks) {
  <div
    [ngClass]="allBookmarks.length > 0 ? 'bookmarks-container bookmark-container-wrapper-v2' : 'none'">
    <h5 class="card-title">{{bookmarks.heading}}</h5>
    <!-- <div class="row"> -->
    <div class="col-12">
      <!-- <div *ngFor="let entity of bookmarksData" class="fav-bookmark">
      <div class="bookmark-chip" [ngClass]="selectedEntity != undefined && selectedEntity[bookmarks.bookmark.datasource.key] == entity[bookmarks.bookmark.datasource.key] ? 'active' : ''" (click)="addEntity(entity)" style="cursor: pointer;">
        <span class="pr-2" data-toggle="tooltip" data-placement="top" title="{{entity[bookmarks.bookmark.datasource.key]}}"> {{getValue(entity[bookmarks.bookmark.datasource.key])}}</span>
        <i class="fa fa-plus-circle"></i>
      </div>
    </div> -->
    <div class="bookmark-main-container-v2" id="bookmark-main-container-v2-{{this.bookmarks.bookmark.type?this.bookmarks.bookmark.type:this.bookmarks.bookmark.resource}}" [ngClass]="expand && expand == true ? 'bm-expand' : ''">
      @if (searchConfig) {
        <div [ngClass]="searchConfig ? 'bookmark-with-search pl-2 pr-2' : 'none'">
          <div class="bookmark-search-container">
            <div class="bookmark-input-search-container">
              <span class="grid-smart-search">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
              @if (searchConfig) {
                <input tabindex="0" type="text" aria-label="multiselect-search "
                  [readOnly]="disabled" [placeholder]="'Search'" [(ngModel)]="dataFromApiModel"
                  (ngModelChange)="filterClick($event)" class="bookmark-search-input form-control"
                  (keydown.enter)="$event.preventDefault()">
              }
            </div>
            <!-- <div class="three-dots-more">
            <span class="more-icon" (click)="toggleFilter($event)">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            </span>
          </div> -->
        </div>
        @if (selectedItems.length > 0 ) {
          <div class="checkbox-actions">
            <div class="checbox-wrapper">
              <div class="table-button-div-box">
                <div class="selection-container">
                  <span class="selected-items">
                    <b>{{selectedItems.length}}</b> selected
                  </span>
                </div>
                <div class="_checkbox-actions">
                  <button type="button"  class="btn-with-icon-label" (click)="addMultipleEntity(selectedItems)">
                    <i class="fa fa fa-check" aria-hidden="true"></i>
                    <span>Add </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
        <div class="radio-action-container">
          <div class="radio-container">
            <label class="radio-wrapper">Self
              <input type="radio" name="basedOn" (change)="getBookMarks(bookmarks.bookmark['cardData'],'doctor', false)">
              <span class="check-mark-radio"></span>
            </label>
            <label class="radio-wrapper">Speciality
              <input type="radio" name="basedOn" (change)="getBookMarks(bookmarks.bookmark['cardData'],'speciality', false)">
              <span class="check-mark-radio"></span>
            </label>
            <label class="radio-wrapper">Department
              <input type="radio" name="basedOn" (change)="getBookMarks(bookmarks.bookmark['cardData'],'department', false)">
              <span class="check-mark-radio"></span>
            </label>
          </div>
        </div>
      </div>
    }
    @if (bookmarksData!=undefined && bookmarksData.length) {
      <div class="bookmark-main-body-v2" id="bookmark-main-body-{{this.bookmarks.bookmark.type?this.bookmarks.bookmark.type:this.bookmarks.bookmark.resource}}"
        [ngClass]="expand && expand == true ? 'scroll-bookmark' : ''" #getElementHeight>
        @for (entity of bookmarksData; track entity; let i = $index) {
          <div class="fav-bookmark">
            <!-- bookmarks.bookmark != undefined && bookmarks.bookmark.config != undefined && bookmarks.bookmark.config.selectType != undefined ? '' :  -->
            <div class="bookmark-chip" [ngClass]="entity.active != undefined && entity.active? 'active' : ''" (click)="addEntity(entity, i)" style="cursor: pointer;">
              <!-- <input *ngIf="bookmarks.bookmark != undefined && bookmarks.bookmark.config != undefined && bookmarks.bookmark.config.selectType != undefined && bookmarks.bookmark.config.selectType == 'multi'" class="checkbox-title" type="checkbox"
              (change)="multiselect(entity, $event.target.checked, i)"> -->
              <span class="pr-2" data-toggle="tooltip" data-placement="top" title="{{entity[bookmarks.bookmark.datasource.key]}}"> {{getValue(entity[bookmarks.bookmark.datasource.key])}}</span>
              <i class="fa fa-plus-circle"></i>
            </div>
            @if (delete_fav && bookmark_config.basedOn == 'doctor' && entity.bookmark_based_on == 'Doctor') {
              <span class="delete_fav" (click)="deleteFavourite(entity, i)"><i class="fa fa-trash ml-1"></i></span>
            }
          </div>
        }
      </div>
    }
    <!-- id: string, elem: ElementRef, type, exp?: string -->
    @if (expandButton) {
      <div class="bookmark-footer-toggle-container" >
        <span class="bm-expand-button" (click)="toggleBtn()">
          <i class="fa fa-chevron-down" aria-hidden="true"></i>
        </span>
      </div>
    }
  </div>
</div>
<!-- </div> -->
</div>
}
<!-- </div> -->
